import React, { Component } from 'react';

import styles from './styles.less';

export enum Type {
	danger = 'danger',
	warning = 'warning',
	note = 'note',
}

interface Props {
	type: Type;
	header: React.ReactNode;
	children: React.ReactNode;
}

export default class InfoText extends Component<Props> {
	render() {
		const { type, header, children } = this.props;

		return (
			<div className={styles[type]}>
				<div className={styles.statusHeader}>{header}</div>
				<p className={styles.statusDescription}>{children}</p>
			</div>
		);
	}
}
